<template>
  <div :class="$style.reports">
    <milestone-page v-if="type === 'milestone'" />
    <statuses-page v-else-if="type === 'statuses'" />
    <portfolio-list-page v-else-if="type === 'portfolio'" />
    <schedule-page v-else-if="type === 'schedule'" />
    <month-page v-else-if="type === 'month'" />
    <div v-else>
      {{ "no page " }}
    </div>
  </div>
</template>

<script>
import milestonePage from './milestoneReportPage.vue';
import statusesPage from './statusesReportPage.vue';
import portfolioListPage from './portfolioListReportPage.vue';
import schedulePage from './scheduleProgressReportPage.vue';
import monthPage from './monthProgressReportPage.vue';

export default {
  components: {
    milestonePage,
    statusesPage,
    portfolioListPage,
    schedulePage,
    monthPage,
  },
  data() {
    return {
      type: null,
      locales: __,
    };
  },
  mounted() {
    this.handleRoute(this.$route);
  },
  watch: {
    $route(newValue) {
      this.handleRoute(newValue);
    },
  },
  methods: {
    handleRoute(route) {
      if (['milestone', 'statuses', 'portfolio', 'schedule', 'month'].includes(route.params?.type)) {
        this.type = route.params?.type;

        return;
      }

      this.$router.push({ name: 'reports' });
    },
  },
};
</script>

<style module src='./../less/reportsMain.less'></style>
